import { action } from 'src/store/actions';

/* Customer Appliances */
export const FETCH_CUSTOMER_APPLIANCES = 'FETCH_CUSTOMER_APPLIANCES';
export const REQUEST_CUSTOMER_APPLIANCES = 'REQUEST_CUSTOMER_APPLIANCES';
export const SUCCESS_CUSTOMER_APPLIANCES = 'SUCCESS_CUSTOMER_APPLIANCES';
export const FAILURE_CUSTOMER_APPLIANCES = 'FAILURE_CUSTOMER_APPLIANCES';

export const fetchCustomerAppliances = () => action(FETCH_CUSTOMER_APPLIANCES);
export const requestCustomerAppliances = () => action(REQUEST_CUSTOMER_APPLIANCES);
export const requestCustomerAppliancesSuccess = (response: any) => action(SUCCESS_CUSTOMER_APPLIANCES, { response });
export const requestCustomerAppliancesFailure = (error: any) => action(FAILURE_CUSTOMER_APPLIANCES, { error });

/* Customer Complaints */
export const FETCH_CUSTOMER_COMPLAINTS = 'FETCH_CUSTOMER_COMPLAINTS';
export const REQUEST_CUSTOMER_COMPLAINTS = 'REQUEST_CUSTOMER_COMPLAINTS';
export const SUCCESS_CUSTOMER_COMPLAINTS = 'SUCCESS_CUSTOMER_COMPLAINTS';
export const FAILURE_CUSTOMER_COMPLAINTS = 'FAILURE_CUSTOMER_COMPLAINTS';

export const fetchCustomerComplaints = () => action(FETCH_CUSTOMER_COMPLAINTS);
export const requestCustomerComplaints = () => action(REQUEST_CUSTOMER_COMPLAINTS);
export const requestCustomerComplaintsSuccess = (response: any) => action(SUCCESS_CUSTOMER_COMPLAINTS, { response });
export const requestCustomerComplaintsFailure = (error: any) => action(FAILURE_CUSTOMER_COMPLAINTS, { error });
